import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const StarBubbleIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 22"
        fill={color}>
        <path clipRule="evenodd"
            d="M11.75 0C5.384 0 0 4.202 0 9.75c0 5.546 5.38 9.747 11.742 9.75a11.3 11.3 0 0 0 3.06-.36l5.665 2.305a.75.75 0 0 0 1.028-.781l-.558-4.835A8.962 8.962 0 0 0 23.5 9.768V9.75C23.5 4.202 18.116 0 11.75 0ZM1.5 9.75c0-4.452 4.416-8.25 10.25-8.25 5.83 0 10.244 3.793 10.25 8.241a7.463 7.463 0 0 1-2.362 5.261.75.75 0 0 0-.233.634l.455 3.942-4.727-1.923a.75.75 0 0 0-.488-.026 9.799 9.799 0 0 1-2.88.371h-.015C5.916 18 1.5 14.202 1.5 9.75Zm12.269-1.971 3.093.45v-.003a.437.437 0 0 1 .242.745l-2.239 2.184.53 3.081a.437.437 0 0 1-.635.46l-2.767-1.454L9.226 14.7a.437.437 0 0 1-.635-.46l.53-3.082-2.239-2.185a.437.437 0 0 1 .242-.745l3.093-.449 1.381-2.803a.455.455 0 0 1 .786 0l1.385 2.803Z"/>
    </svg>
);
StarBubbleIcon.displayName = 'StarBubbleIcon';
export default StarBubbleIcon;
